import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { DecimalPipe, NgClass } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface CancelPreviewLineItem {
  key: string;
  label: string;
  amount: number;
  type: string;
  refundable: boolean | null;
}

export interface CancelPreviewResponse {
  context: string;
  currency: string;
  line_items: CancelPreviewLineItem[];
  totals: {
    paid_amount: number;
    final_amount: number;
    final_amount_label: string;
  };
  refund_meta: {
    method: string;
    expected_days: string;
  };
}

@Component({
  selector: 'app-cancel-appointment-dialog',
  templateUrl: './cancel-appointment-dialog.component.html',
  styleUrls: ['./cancel-appointment-dialog.component.css'],
  standalone: true,
  imports: [
    NgClass,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    DecimalPipe
  ],
})
export class CancelAppointmentDialogComponent implements OnInit {
  isLoading = true;
  isConfirming = false;
  hasError = false;
  preview: CancelPreviewResponse | null = null;

  constructor(
    public dialogRef: MatDialogRef<CancelAppointmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { appointmentId: string },
    @Inject(AuthService) private auth: AuthService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.loadPreview();
  }

  loadPreview(): void {
    this.isLoading = true;
    this.hasError = false;

    this.auth.getCancelPreview(this.data.appointmentId).subscribe({
      next: (res: any) => {
        this.preview = res as CancelPreviewResponse;
        this.isLoading = false;
      },
      error: () => {
        this.hasError = true;
        this.isLoading = false;
      },
    });
  }

  formatRefundMethod(method: string): string {
    if (!method) return '';
    return method
      .split('_')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }

  confirmCancel(): void {
    this.isConfirming = true;
    this.auth.deleteAppointment(this.data.appointmentId).subscribe({
      next: (res: any) => {
        this.isConfirming = false;
        this.dialogRef.close(true);
      },
      error: (err: any) => {
        this.isConfirming = false;
        const msg = err?.error?.msg || 'Cancellation failed. Please try again.';
        this.toastr.error(msg);
      },
    });
  }

  keepAppointment(): void {
    this.dialogRef.close(false);
  }
}
